export default __webpack_public_path__ + "static/media/bsc-blue.1bcdc647.svg";